module.exports = __webpack_public_path__ + "media/images/lb/387-eb9783f062799aaa9a7217b7d4bfa21d.svg";